<template>
    <div>
        <el-dialog
                :close-on-click-modal="false"
                :title="entryType=='detail'?'建议详情':'建议回复'"
                :visible.sync="show"
                width="600px"
                >
            <div v-loading="loading">
                <div class="w100 pl20 pr20">
                    <el-form label-width="100px" :model="resultData"  ref="ruleForm" class="demo-form-inline">
                        <el-form-item v-if="entryType=='detail'" label="建议人"  >
                            <el-input v-model="resultData.createUser" readonly></el-input>
                        </el-form-item>
                        <el-form-item v-if="entryType=='detail'" label="建议时间"  >
                            <el-input v-model="resultData.adviceTime" readonly></el-input>
                        </el-form-item>
                        <el-form-item v-if="entryType=='detail'" label="建议类型" >
                            <el-input v-model="type" readonly></el-input>
                        </el-form-item>
                        <el-form-item v-if="entryType=='detail'" label="建议内容" >
                            <div class="msg-detail">
                                <!--<div class="msg-detail-content" v-text="resultData.content">-->

                                <!--</div>-->

                                <!--<div v-if="attachUrl">-->
                                    <!---->
                                <!--</div>-->
                                <div class="msg-item cl-f other">
                                    <div class="str-warp">
                                        <div>{{resultData.createUser+': '+resultData.adviceTime}}</div>
                                        <div class="msg-str">{{resultData.content}}
                                            <div @click="download" class="msg-detail-load" v-if="attachUrl">点击附件下载</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="msg-item cl-f self" v-if="status == 1&&entryType=='detail'">

                                    <div class="str-warp">
                                        <div>{{resultData.answerUser+': '+resultData.answerTime}}</div>
                                        <div class="msg-str">{{resultData.answer}}</div>
                                    </div>
                                </div>
                            </div>
                        </el-form-item>
                        <el-form-item v-if="entryType=='answer'" label="回复内容" >
                            <el-input rows="5" v-model="resultData.answer"
                                    :readonly="entryType!='answer'"  type="textarea" placeholder="请输入要回复的内容"></el-input>
                        </el-form-item>
                    </el-form>

                </div>

            </div>
            <div slot="footer" v-if="entryType=='answer'" class="dialog-footer">
                <el-button @click="submitForm('ruleForm')" type="primary">确 定</el-button>
                <el-button @click="show = false">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import { adviceEdit} from '@/api/managementCenter/advices';
    export default {
        name: "Advice",
        components: {},
        props: [],
        data() {
            return {
                id:'',
                entryType:'',
                show: false,
                loading: false,
                resultData:{answer:''},
                type:'',
                status:'',
                attachUrl:''
            };
        },
        computed: {

        },
        methods: {
            // 确定提交
            submitForm (formName) {
                if (!this.resultData.answer) {
                    this.$message.warning("请输入要留言的内容!");
                    return;
                }

                this.adviceEditFn()
            },
            adviceEditFn(){
                this.loading = true;
                let params={
                    id:this.id,
                    answer:this.resultData.answer
                }
                adviceEdit(params).then(({data})=>{
                    this.loading = false;
                    if(data.code==0){
                        this.$message.success(  "回复成功!" );
                        this.$emit('saveSuccess')
                        this.show=false;
                    }else{
                        this.$message.warning(data.msg||"回复失败!" );
                    }

                }).catch(err=>{
                    this.$message.error(  "服务器异常!" );
                    this.loading = false;
                })
            },
            // 显示弹框
            dialogShow(entryType,id,data,type,status,attachUrl) {
                this.entryType=entryType;
                this.id=id;
                this.show=true;


                if(entryType=="detail"){
                    this.type=type;
                    this.status=status;
                    this.attachUrl=attachUrl;
                    this.$nextTick(()=>{
                        this.resultData =data;
                    })
                }else{
                    this.resultData.answer ='';
                }
            },
            download(){
                window.location.href=this.attachUrl;
            }

        },
        watch: {
            show(val){
                if(!val){
                    this.resultData.answer ='';

                }

            }

        },
        filters: {}
    };
</script>

<style scoped lang="less">
    .msg-detail{
        border-radius: 4px;
        border: 1px solid #DCDFE6;
        height: 200px;
        overflow: auto;
        background: #F2F4F5;
        padding: 20px 0;
        .msg-item{
            padding: 2px 10px ;
            font-size: 12px;
            margin-top: 10px;

            .msg-str{
                display: inline-block;
                max-width: 60%;
                padding:5px 10px ;
                border-radius:6px;
                line-height: 20px;

            }
        }
        .other{
            .name-warp{
                margin-top: 10px;
                height: 20px;
                line-height: 20px;
                text-align: left;
                padding-left: 5px;
            }
            .str-warp{
                text-align: left;
                .msg-str{
                    background: #fff;
                    position: relative;
                    margin-left: 3px;
                    .msg-detail-load{
                        color: #2cacf0;
                        text-decoration: underline;
                        cursor: pointer;
                    }
                    &:before{
                        content: '';
                        display: block;
                        width: 0;
                        height: 0;
                        border: 8px solid transparent;
                        position: absolute;
                        top: 5px;
                        border-right: 8px solid #fff;
                        left: -13px;


                    }
                }
            }

        }
        .self{
            .name-warp{
                margin-top: 10px;
                height: 20px;
                line-height: 20px;
                text-align: right;
                padding-right: 5px;
            }
            .str-warp{
                text-align: right;
                .msg-str{
                    background: #8CE050;
                    color: #fff;
                    position: relative;
                    margin-right: 3px;

                    &:after{
                        content: '';
                        display: block;
                        width: 0;
                        height: 0;
                        border: 8px solid transparent;
                        position: absolute;
                        top: 5px;
                        border-left: 8px solid #8CE050;
                        right: -13px;

                    }



                }

            }

        }


    }
</style>
